import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppInitializer from './components/AppInitializer';
import AppRoutes from './routes';
import './pages/AuthPages.css';

function App() {
  return (
    <Router>
      <AppInitializer>
        <div className="App">
          <AppRoutes />
        </div>
      </AppInitializer>
    </Router>
  );
}

export default App;
